export default __webpack_public_path__ + "static/media/IMG_8600.ffec59bb.jpg";